const languages = ['en', 'fr'];
const catalogs = {
  en: require('./locale/en/messages.js'),
  fr: require('./locale/fr/messages.js'),
};

const defaultLanguage = 'en';

const prefix = lang => (lang === defaultLanguage ? '' : `/${lang}`);
const deprefix = pathname => (pathname.startsWith('/fr/') ? pathname.substr(4) : pathname);
const langFromPath = pathname => (pathname.startsWith('/fr/') ? 'fr' : 'en');

exports.defaultLanguage = defaultLanguage;
exports.languages = languages;
exports.catalogs = catalogs;
exports.prefix = prefix;
exports.deprefix = deprefix;
exports.langFromPath = langFromPath;
